import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('circles', 'decline-guardian-role');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'guardian_proxy_invitations',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/circles/decline-guardian-role.js